import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Toaster } from "./ui/toaster";

const PageLayout = ({ children }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      <main className="flex-1 pt-20">{children}</main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default PageLayout;
